<template>
  <div class="user" v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      <div class="common-form">参数设置</div>
      <el-form-item label="接口请求地址：" :rules="[{required: true,message: '接口请求地址不能为空'}]" prop="url">
        <el-input v-model="form.url" class="max-w460"  ></el-input>
      </el-form-item>
      <el-form-item label="应用appid：" :rules="[{required: true,message: '应用appid不能为空'}]" prop="appid">
        <el-input v-model="form.appid" class="max-w460"  ></el-input>
      </el-form-item>
      <el-form-item label="应用密钥：" :rules="[{required: true,message: '应用密钥不能为空'}]" prop="appkey">
        <el-input v-model="form.appkey" class="max-w460" ></el-input>
      </el-form-item>
      <el-form-item label="固定版本号：" :rules="[{required: true,message: '固定版本号不能为空'}]" prop="version">
        <el-input v-model="form.version" class="max-w460" ></el-input>
      </el-form-item>
      
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
      </div>
    </el-form>

    
  </div>
<!-- private $url = "http://yyapi.5duang.com/ApiOrder/Getway";   // 请求地址
    private $appid='00003';    // 应用appid
    private $version='1.0';    // 固定版本号
    private $appkey = 'VpCJtXHbEurTqXC+Oh8jw';  // 密钥 -->
</template>

<script>
  import GcardApi from '@/api/gcard.js'
export default {
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*表单对象*/
      form: {
        url: '',
        appid: '',
        version: '',
        appkey: '',
      },
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*获取数据*/
    getData(){
      let self = this;
      self.loading = true;
      GcardApi.getData({}, true)
        .then(res => {
          self.form = res.data.detail;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      // console.log(params);
      self.$refs.form.validate((valid) => {
        console.log(valid)
          if (valid) {
            self.loading = true;
            GcardApi.saveData(self.form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，保存成功',
                  type: 'success'
                });
                this.getData();
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      
    },

  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/gcard/setting/index.vue